<script setup lang="ts">
import {
  useRouterStore,
  useStatsigEventsStore,
} from '@apps/main/new-desktop/core/stores';

import { AppSvgIcon, AppRouterLink } from '@libs/ui';

const routerStore = useRouterStore();
const statsigEventsStore = useStatsigEventsStore();

interface AccommodationCardSelectedFooterProps {
  ingredientIndex: number;
}
const props = defineProps<AccommodationCardSelectedFooterProps>();

function onNavigationTriggered(): void {
  statsigEventsStore.logTripOverviewExploreMoreHotelCardClicked();
}
</script>

<template>
  <AppRouterLink
    class="accommodation-card-selected-footer-link"
    :link="
      routerStore.getHotelSelectionUrl({
        ingredientIndex: props.ingredientIndex,
      })
    "
    font="font-link-s-light"
    color="color-soft-black"
    wide
    @navigation-triggered="onNavigationTriggered"
  >
    <div class="accommodation-card-selected-footer">
      <div class="information">
        <span>{{ $t('overview_stay_footer.not_right') }}</span>
        <div>
          <div class="link-wrapper">
            <AppSvgIcon name="lookingGlass" size="18" />
            <span class="link-text">
              {{ $t('overview_stay_footer.explore') }}
            </span>
          </div>
        </div>
      </div>
      <div class="label">
        {{ $t('planner.included') }}
      </div>
    </div>
  </AppRouterLink>
</template>

<style scoped lang="scss">
.accommodation-card-selected-footer-link {
  text-decoration: unset;
  width: 100%;

  .accommodation-card-selected-footer {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;

    border-radius: var(--border-radius-8);
    gap: var(--spacing-4);

    .information {
      @include font-link-s-bold;
      color: var(--color-soft-black);
      display: flex;
      flex-direction: column;
      gap: var(--spacing-4);

      .link-wrapper {
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: var(--spacing-4);
        .link-text {
          @include font-link-s-light;
          text-decoration: underline;
        }
      }
    }
    .label {
      color: var(--color-neutral-70);
      padding: 0;
      @include font-body-m-bold;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: var(--spacing-8);
      height: fit-content;
    }
  }
}
</style>
